  <template>
    <div>
      <div class="mt-5">
        <p>
          <b class="txt-prim title1">Contacto</b>
        </p>
        <div class="col-12 col-md-6 mb-5">
          <div class="row justify-content-between mb-4">
            <div class="col-md-6 col-12 my-2">
              <span for="">Nombre</span>
              <input class="w-100 p-2 input-text" v-model="body.name" placeholder="Nombre completo" type="text">
            </div>
            <div class="col-md-6 col-12 my-2">
              <span for="">Email</span>
              <input class="w-100 p-2 input-text" v-model="body.mail" placeholder="name@example.com" type="email">
            </div>
          </div>
          <div>
            <b-form-textarea id="textarea1"
                            v-model="body.description"
                            class="input-text"
                            placeholder="Escribe tu mensaje"
                            :rows="3"
                            :max-rows="6">
            </b-form-textarea>
          </div>
          <div class="d-flex my-3">
            <b-button :disabled="validateEmail" class="ml-auto btn-custom" variant="success" @click="sendEmail">Enviar</b-button>
          </div>
        </div>
      </div>
       <b-alert :show="dismissCountDown"
             dismissible
             fade
             :variant="variant"
             @dismissed="dismissCountDown=0"
             @dismiss-count-down="countDownChanged">
            Tu mensaje {{res}} enviado
    </b-alert>
    </div>
  </template>
<script>
import axios from 'axios';
export default {
  data(){
    return {
      body: {
        mail: '',
        name: '',
        description: '',
      },
      dismissSecs: 5,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      variant: 'success',
      res: '',
      dis : true
    }
  },

  computed: {
    validateEmail: function(){
      if(this.body.name && this.body.mail && this.body.description) {
        return false;
      }
      else {
        return true;
      }
    }
  },
  methods: {
    sendEmail: function() {
    let data = {
        mail: this.body.mail,
        name: this.body.name,
        description: this.body.description
      }
      // console.log(data)
        axios.post('https://pp5795pu60.execute-api.us-east-1.amazonaws.com/default/basicContactForm', data)
        .then(()=> {
          this.variant = 'success';
          this.res = 'ha'
          this.showAlert()
        })
        .catch(()=> {
          this.res = 'no ha sido';
          this.variant = 'danger';
          this.showAlert()
        })
        debugger
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contact.vue